// src/services/notifications/strategies/WhatsAppStrategy.js
import { WhatsAppProviderFactory } from './WhatsAppProviderFactory';
import { notificationConfig } from '@/config/notification.config';

export class WhatsAppStrategy {
  constructor() {
    console.log("WhatsAppStrategy: Iniciando construtor");
    
    // Cache para os provedores criados
    this.providers = new Map();
    
    // Criar os provedores para todos os perfis configurados
    try {
      // Primeiro, criar o provedor padrão
      const defaultProfile = notificationConfig.defaultWhatsappProfile;
      this.defaultProvider = WhatsAppProviderFactory.create(defaultProfile);
      this.providers.set(defaultProfile, this.defaultProvider);
      
      console.log("WhatsAppStrategy: Provider padrão criado com sucesso para perfil:", defaultProfile);
      
      // Depois, criar os demais provedores
      Object.keys(notificationConfig.whatsappProfiles).forEach(profileName => {
        if (profileName !== defaultProfile) {
          this.providers.set(profileName, WhatsAppProviderFactory.create(profileName));
          console.log("WhatsAppStrategy: Provider criado para perfil:", profileName);
        }
      });
    } catch (error) {
      console.error("WhatsAppStrategy: Erro ao criar providers:", error);
      throw error;
    }
  }

  // Obter o provedor para um perfil específico
  getProvider(profileName = null) {
    if (!profileName) {
      return this.defaultProvider;
    }
    
    const provider = this.providers.get(profileName);
    if (!provider) {
      console.warn(`WhatsAppStrategy: Perfil ${profileName} não encontrado, usando provedor padrão`);
      return this.defaultProvider;
    }
    
    return provider;
  }

  async sendWhatsappTemplate(template, params, to, profileName = null) {
    console.log("WhatsAppStrategy: sendWhatsappTemplate chamado com template:", template, "perfil:", profileName);
    
    const provider = this.getProvider(profileName);
    
    if (!provider) {
      console.error("WhatsAppStrategy: Provider não disponível");
      return false;
    }
    
    try {
      return await provider.sendTemplate(template, params, to);
    } catch (error) {
      console.error("WhatsAppStrategy: Erro ao enviar template:", error);
      return false;
    }
  }

  async send(payload, profileName = null) {
    console.log("WhatsAppStrategy: send chamado com payload:", payload, "perfil:", profileName);
    
    const provider = this.getProvider(profileName);
    
    if (!provider) {
      console.error("WhatsAppStrategy: Provider não disponível");
      return false;
    }
    
    try {
      return await provider.send(payload);
    } catch (error) {
      console.error("WhatsAppStrategy: Erro ao enviar mensagem:", error);
      return false;
    }
  }
}